import { Component, effect, ChangeDetectionStrategy } from '@angular/core';
import { Category, RegistryEntry, Type } from '@xanadu/model';
import { NodeComponent } from '@xanadu/core';


@Component({
    selector: 'app-type-node',
    templateUrl: './type-node.component.html',
    styleUrls: ['./type-node.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TypeNodeComponent extends NodeComponent {
    protected get nodeType(): string | undefined {
        return 'type';
    }

    private iconRoot = 'account_tree';
    private iconCategory = 'folder';
    private iconType = 'view_list';

    constructor(
    ) {
        super();

        effect(() => {
            const model = this.model();

            if (model?.node instanceof Category) {
                if (model.node.parentId) {
                    this.icon = this.iconCategory;
                } else {
                    this.icon = this.iconRoot;
                }
            } else if (model?.node instanceof Type) {
                this.icon = this.iconType;
            }
        });
    }
}
